import { paths } from 'ogp/paths';
import { mapOgpSidebarItems, withSectionChildren } from './ogp-sidebar-section-helpers';
import { OgpSidebarItems } from './ogp-sidebar-items.types';

export const filterManagementAdminSettingsSidebarItems = (
  sidebarItems: OgpSidebarItems,
  companyRoles: string[] | undefined
): OgpSidebarItems => {
  const hasCompanyRoles = !!companyRoles?.length;
  const isAnyAdmin = companyRoles?.includes('HQADMIN') || companyRoles?.includes('ADMIN');

  if (hasCompanyRoles && isAnyAdmin) {
    return sidebarItems;
  }

  return mapOgpSidebarItems(sidebarItems, (section) =>
    section.key === 'management'
      ? withSectionChildren(
          section,
          section.children.filter((child) => child.path !== paths.Settings.path)
        )
      : section
  );
};
